var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMwaliFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_8471)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "#5196ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_597_8471",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -3,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_597_8471)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 9V15H28V9H-4Z",
    fill: "#AF0100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 3V9H28V3H-4Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V3H28V-3H-4Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3L15 9L-4 21V-3Z",
    fill: "#5EAA22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.37354 8.44922C-2.22721 4.02874 2.34572 2.94734 3.62354 3.87012C3.62354 3.87012 -0.0251141 4.62042 -0.151855 8.44922C-0.277864 12.2566 3.26467 13.4874 3.3042 13.501C1.94139 13.8514 -2.51981 12.8693 -2.37354 8.44922ZM4.29346 11.5957L4.95068 11.6914L4.4751 12.1543L4.5874 12.8086L3.99951 12.5L3.4126 12.8086L3.52393 12.1543L3.04932 11.6914L3.70557 11.5957L3.99951 11L4.29346 11.5957ZM4.29346 9.5957L4.95068 9.69141L4.4751 10.1543L4.5874 10.8086L3.99951 10.5L3.4126 10.8086L3.52393 10.1543L3.04932 9.69141L3.70557 9.5957L3.99951 9L4.29346 9.5957ZM4.29346 7.5957L4.95068 7.69141L4.4751 8.1543L4.5874 8.80859L3.99951 8.5L3.4126 8.80859L3.52393 8.1543L3.04932 7.69141L3.70557 7.5957L3.99951 7L4.29346 7.5957ZM4.29346 5.5957L4.95068 5.69141L4.4751 6.1543L4.5874 6.80859L3.99951 6.5L3.4126 6.80859L3.52393 6.1543L3.04932 5.69141L3.70557 5.5957L3.99951 5L4.29346 5.5957Z",
    fill: "#F7FCFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_8471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMwaliFlagIcon);
export default __webpack_public_path__ + "static/media/mwaliFlagIcon.c62103b4b0b66638c89238db450d254a.svg";
export { ForwardRef as ReactComponent };